export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
  isVip: boolean;
}

export interface ComicReview {
  id: string;
  userName: string;
  userAvatar: string;
  rating: number;
  title: string;
  content: string;
  date: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  tags: string[];
  coverImage: string;
  bannerImage: string;
  description: string;
  longDescription: string;
  rating: number;
  totalViews: number;
  status: '连载中' | '已完结';
  updatedAt: string;
  chapters: ComicChapter[];
  reviews: ComicReview[];
}

export interface ComicCategory {
  name: string;
  slug: string;
  description: string;
  image: string;
  count: number;
}

export const categories: ComicCategory[] = [
  {
    name: '恋爱浪漫',
    slug: 'romance',
    description: '甜蜜的爱情故事，从心动到永恒的浪漫旅程，让你感受最纯粹的情感碰撞。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20style%20illustration%20of%20a%20couple%20under%20cherry%20blossoms%20at%20sunset%2C%20warm%20pink%20and%20orange%20tones%2C%20soft%20dreamy%20atmosphere%2C%20cinematic%20lighting%2C%20emotional%20romantic%20scene%2C%20anime%20art%20style%2C%20beautiful%20composition%20with%20falling%20petals%2C%20clean%20simple%20background&width=800&height=450&seq=cat-romance-01&orientation=landscape',
    count: 256,
  },
  {
    name: '动作冒险',
    slug: 'action',
    description: '热血沸腾的战斗场面，惊险刺激的冒险旅程，带你进入最燃的漫画世界。',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20Korean%20manhwa%20action%20scene%20with%20epic%20battle%20pose%2C%20dramatic%20lighting%20with%20warm%20orange%20energy%20effects%2C%20dark%20atmospheric%20background%2C%20powerful%20warrior%20silhouette%2C%20cinematic%20composition%2C%20anime%20style%20illustration%2C%20intense%20and%20thrilling%20mood%2C%20clean%20composition&width=800&height=450&seq=cat-action-01&orientation=landscape',
    count: 189,
  },
  {
    name: '奇幻魔法',
    slug: 'fantasy',
    description: '剑与魔法的世界，龙与英雄的传说，在奇幻大陆上展开史诗般的冒险。',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20Korean%20manhwa%20style%20magical%20landscape%20with%20floating%20crystals%20and%20ancient%20ruins%2C%20warm%20golden%20magical%20glow%2C%20mystical%20atmosphere%2C%20epic%20fantasy%20world%2C%20soft%20ethereal%20lighting%2C%20anime%20art%20style%2C%20beautiful%20dreamy%20composition%2C%20clean%20simple%20design&width=800&height=450&seq=cat-fantasy-01&orientation=landscape',
    count: 134,
  },
  {
    name: '悬疑惊悚',
    slug: 'thriller',
    description: '扣人心弦的悬疑故事，出人意料的剧情反转，让你欲罢不能的推理体验。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20Korean%20manhwa%20style%20illustration%20with%20shadowy%20alley%20and%20detective%20silhouette%2C%20deep%20blue%20and%20warm%20amber%20lighting%20contrast%2C%20noir%20atmosphere%2C%20suspenseful%20mood%2C%20anime%20art%20style%2C%20cinematic%20composition%2C%20clean%20simple%20background&width=800&height=450&seq=cat-thriller-01&orientation=landscape',
    count: 97,
  },
  {
    name: '职场生活',
    slug: 'office',
    description: '办公室里的爱恨情仇，职场中的成长故事，写实又温暖的都市生活漫画。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20office%20manhwa%20style%20illustration%20with%20stylish%20young%20professionals%20in%20city%20skyline%20background%2C%20warm%20sunset%20lighting%20through%20glass%20windows%2C%20chic%20urban%20atmosphere%2C%20anime%20art%20style%2C%20clean%20composition%2C%20professional%20yet%20warm%20mood&width=800&height=450&seq=cat-office-01&orientation=landscape',
    count: 78,
  },
  {
    name: '科幻未来',
    slug: 'scifi',
    description: '未来世界、人工智能、星际旅行，最具想象力的科幻漫画等你探索。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20Korean%20manhwa%20sci-fi%20cityscape%20with%20neon%20lights%20and%20holograms%2C%20cyberpunk%20atmosphere%2C%20warm%20orange%20and%20cool%20teal%20lighting%20contrast%2C%20sleek%20futuristic%20aesthetic%2C%20anime%20art%20style%2C%20cinematic%20composition%2C%20clean%20modern%20design&width=800&height=450&seq=cat-scifi-01&orientation=landscape',
    count: 63,
  },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    slug: 'her-secret-lessons',
    title: '她的秘密教学',
    author: '朴智恩',
    category: '恋爱浪漫',
    categorySlug: 'romance',
    tags: ['恋爱', '师生', '甜蜜'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20style%20illustration%20of%20a%20beautiful%20young%20woman%20with%20long%20dark%20hair%20in%20school%20uniform%2C%20soft%20romantic%20atmosphere%2C%20warm%20pink%20and%20peach%20tones%2C%20anime%20art%20style%2C%20clean%20simple%20background%20with%20soft%20bokeh%20lights%2C%20elegant%20composition&width=800&height=1067&seq=comic-cover-01&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20banner%20illustration%20of%20two%20characters%20in%20school%20setting%20at%20sunset%2C%20warm%20golden%20lighting%2C%20emotional%20atmosphere%2C%20anime%20art%20style%2C%20cinematic%20wide%20composition%2C%20soft%20dreamy%20mood%2C%20elegant%20design&width=1600&height=600&seq=comic-banner-01&orientation=landscape',
    description: '平凡的女高中生意外发现了班主任不为人知的秘密，从此两人之间展开了微妙的关系变化。',
    longDescription: '金多美是一名普通的高中女生，成绩平平，性格内向。某天放学后，她无意中目睹了班主任韩智浩与某人的秘密会面。这个发现让她的生活发生了翻天覆地的变化 — 韩老师开始特别关注她，而她也逐渐被这位神秘又有魅力的老师吸引。两人之间若即若离的关系，在校园的日常点滴中慢慢升温。这是一部讲述师生之间微妙情感的甜蜜恋爱漫画，画风精美，剧情细腻动人。',
    rating: 4.8,
    totalViews: 1280000,
    status: '连载中',
    updatedAt: '2026-07-04',
    chapters: [
      { id: 'ch-1-1', title: '第1话：意外的发现', number: 1, updatedAt: '2026-01-15', isVip: false },
      { id: 'ch-1-2', title: '第2话：沉默的注视', number: 2, updatedAt: '2026-01-22', isVip: false },
      { id: 'ch-1-3', title: '第3话：放学后的辅导', number: 3, updatedAt: '2026-01-29', isVip: false },
      { id: 'ch-1-4', title: '第4话：雨中的告白', number: 4, updatedAt: '2026-02-05', isVip: false },
      { id: 'ch-1-5', title: '第5话：心跳的距离', number: 5, updatedAt: '2026-02-12', isVip: false },
      { id: 'ch-1-6', title: '第6话：夏日的约定', number: 6, updatedAt: '2026-02-19', isVip: false },
      { id: 'ch-1-7', title: '第7话：秘密的代价', number: 7, updatedAt: '2026-02-26', isVip: false },
      { id: 'ch-1-8', title: '第8话：无法言说', number: 8, updatedAt: '2026-03-05', isVip: true },
      { id: 'ch-1-9', title: '第9话：深夜的讯息', number: 9, updatedAt: '2026-03-12', isVip: true },
    ],
    reviews: [
      { id: 'rv-1-1', userName: '漫画迷小兔', userAvatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%2C%20simple%20portrait%2C%20clean%20background%2C%20kawaii%20style&width=100&height=100&seq=avatar-01&orientation=squarish', rating: 5, title: '画风太美了！', content: '这部漫画的画风简直绝了，每一帧都可以当壁纸。剧情也是甜到让人心动，男女主之间的互动特别自然。强烈推荐！', date: '2026-06-28' },
      { id: 'rv-1-2', userName: '深夜追漫人', userAvatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20boy%20avatar%20with%20dark%20hair%2C%20simple%20portrait%2C%20clean%20background%2C%20modern%20style&width=100&height=100&seq=avatar-02&orientation=squarish', rating: 5, title: '一口气看到最新', content: '从第一话开始就停不下来了，剧情节奏把握得很好，不会拖沓。韩老师太有魅力了，期待后续发展！', date: '2026-06-25' },
    ],
  },
  {
    id: 'comic-2',
    slug: 'urban-cultivation-reborn',
    title: '重生之都市修仙',
    author: '金明洙',
    category: '动作冒险',
    categorySlug: 'action',
    tags: ['重生', '修仙', '都市', '热血'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20style%20illustration%20of%20a%20powerful%20male%20character%20with%20glowing%20energy%20surrounding%20him%2C%20urban%20cityscape%20background%2C%20dramatic%20action%20pose%2C%20warm%20orange%20and%20gold%20energy%20effects%2C%20anime%20art%20style%2C%20clean%20dynamic%20composition&width=800&height=1067&seq=comic-cover-02&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20Korean%20manhwa%20banner%20of%20cultivator%20in%20modern%20city%20with%20magical%20energy%2C%20dramatic%20golden%20lighting%2C%20anime%20art%20style%2C%20cinematic%20wide%20composition%2C%20powerful%20atmosphere&width=1600&height=600&seq=comic-banner-02&orientation=landscape',
    description: '一代仙尊渡劫失败，重回地球少年时代，凭借前世记忆，开启都市修仙之路。',
    longDescription: '仙界第一人林天，在渡九重天劫时遭人暗算，含恨陨落。然而天无绝人之路，他竟重生回到了地球的少年时代。这一世，他不再追求虚无缥缈的仙道，而是要在都市中活出精彩人生。凭借前世的修仙记忆，他在都市中崛起，炼丹、炼器、布阵、治病，无所不能。曾经的敌人、曾经的遗憾，这一世他一个都不会放过。热血沸腾的都市修仙故事，带你感受不一样的爽文体验！',
    rating: 4.9,
    totalViews: 2560000,
    status: '连载中',
    updatedAt: '2026-07-03',
    chapters: [
      { id: 'ch-2-1', title: '第1话：仙尊重生', number: 1, updatedAt: '2026-02-01', isVip: false },
      { id: 'ch-2-2', title: '第2话：少年归来', number: 2, updatedAt: '2026-02-08', isVip: false },
      { id: 'ch-2-3', title: '第3话：初显身手', number: 3, updatedAt: '2026-02-15', isVip: false },
      { id: 'ch-2-4', title: '第4话：校花求助', number: 4, updatedAt: '2026-02-22', isVip: false },
      { id: 'ch-2-5', title: '第5话：踏灭豪门', number: 5, updatedAt: '2026-03-01', isVip: false },
      { id: 'ch-2-6', title: '第6话：丹道大师', number: 6, updatedAt: '2026-03-08', isVip: false },
      { id: 'ch-2-7', title: '第7话：古武世家', number: 7, updatedAt: '2026-03-15', isVip: true },
      { id: 'ch-2-8', title: '第8话：昆仑秘境', number: 8, updatedAt: '2026-03-22', isVip: true },
    ],
    reviews: [
      { id: 'rv-2-1', userName: '热血少年', userAvatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20male%20avatar%20with%20spiky%20hair%2C%20simple%20portrait%2C%20clean%20background%2C%20modern%20style&width=100&height=100&seq=avatar-03&orientation=squarish', rating: 5, title: '爽文天花板！', content: '重生修仙类的漫画里这部绝对算顶级了，剧情不拖沓，打斗场面画得特别震撼。每次更新都第一时间看！', date: '2026-07-01' },
      { id: 'rv-2-2', userName: '漫画达人', userAvatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20cool%20character%20avatar%20with%20glasses%2C%20simple%20portrait%2C%20clean%20background%2C%20intellectual%20style&width=100&height=100&seq=avatar-04&orientation=squarish', rating: 4, title: '设定很有意思', content: '修仙+都市的设定很新颖，主角性格也讨喜。不过有些剧情略显套路，整体还是非常值得一看的。', date: '2026-06-30' },
    ],
  },
  {
    id: 'comic-3',
    slug: 'sweet-trap',
    title: '甜蜜的陷阱',
    author: '李秀雅',
    category: '恋爱浪漫',
    categorySlug: 'romance',
    tags: ['恋爱', '契约', '总裁'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20style%20illustration%20of%20an%20elegant%20woman%20in%20luxurious%20dress%20with%20a%20handsome%20man%20in%20suit%2C%20romantic%20tension%2C%20warm%20golden%20lighting%2C%20anime%20art%20style%2C%20clean%20sophisticated%20composition%2C%20soft%20background&width=800&height=1067&seq=comic-cover-03&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Luxurious%20Korean%20manhwa%20banner%20of%20elegant%20couple%20in%20penthouse%20at%20night%2C%20warm%20romantic%20lighting%2C%20anime%20art%20style%2C%20cinematic%20wide%20composition%2C%20sophisticated%20atmosphere&width=1600&height=600&seq=comic-banner-03&orientation=landscape',
    description: '为了偿还家族债务，她被迫与财阀继承人签订契约婚姻，没想到这竟是一场精心设计的甜蜜陷阱。',
    longDescription: '姜素熙的家族企业一夜之间破产，负债累累的她走投无路。这时，韩国最大财阀的继承人车敏俊提出了一个交易 — 与他契约结婚三年，他会帮她还清所有债务。别无选择的她答应了。然而婚后生活并非她想象中那样冰冷，车敏俊对她的温柔体贴让她逐渐沦陷。但当她发现自己爱上他时，却意外得知这一切都是他精心设计的陷阱。他究竟是为了什么？这场婚姻背后隐藏着怎样的秘密？',
    rating: 4.7,
    totalViews: 1890000,
    status: '连载中',
    updatedAt: '2026-07-02',
    chapters: [
      { id: 'ch-3-1', title: '第1话：破产千金', number: 1, updatedAt: '2026-03-01', isVip: false },
      { id: 'ch-3-2', title: '第2话：契约婚姻', number: 2, updatedAt: '2026-03-08', isVip: false },
      { id: 'ch-3-3', title: '第3话：新婚之夜', number: 3, updatedAt: '2026-03-15', isVip: false },
      { id: 'ch-3-4', title: '第4话：丈夫的秘密', number: 4, updatedAt: '2026-03-22', isVip: false },
      { id: 'ch-3-5', title: '第5话：意外的温柔', number: 5, updatedAt: '2026-03-29', isVip: false },
      { id: 'ch-3-6', title: '第6话：情敌登场', number: 6, updatedAt: '2026-04-05', isVip: true },
      { id: 'ch-3-7', title: '第7话：真心或假意', number: 7, updatedAt: '2026-04-12', isVip: true },
    ],
    reviews: [
      { id: 'rv-3-1', userName: '追漫少女', userAvatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20brown%20hair%2C%20simple%20portrait%2C%20clean%20background%2C%20sweet%20style&width=100&height=100&seq=avatar-05&orientation=squarish', rating: 5, title: '男主太撩了', content: '车敏俊简直是理想型！高冷又温柔，每次看到他关心素熙的时候都忍不住尖叫。剧情也越来越精彩了！', date: '2026-06-29' },
    ],
  },
  {
    id: 'comic-4',
    slug: 'dark-lord',
    title: '暗夜君主',
    author: '郑宇成',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    tags: ['悬疑', '暗黑', '复仇', '动作'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20style%20dark%20illustration%20of%20mysterious%20man%20in%20black%20coat%20standing%20in%20rainy%20alley%2C%20noir%20atmosphere%2C%20deep%20shadows%2C%20warm%20amber%20streetlight%2C%20anime%20art%20style%2C%20clean%20dramatic%20composition&width=800&height=1067&seq=comic-cover-04&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Dark%20noir%20Korean%20manhwa%20banner%20of%20city%20at%20night%20with%20mysterious%20figure%20on%20rooftop%2C%20dramatic%20lighting%2C%20anime%20art%20style%2C%20cinematic%20wide%20composition%2C%20suspenseful%20mood&width=1600&height=600&seq=comic-banner-04&orientation=landscape',
    description: '白天是普通上班族，夜晚化身城市暗夜中的审判者。他以暴制暴，向那些逍遥法外的罪犯展开复仇。',
    longDescription: '五年前，检察官韩振宇的家人被黑帮残忍杀害，而幕后黑手却因证据不足被当庭释放。从那以后，他消失了。五年后，城市中出现了一个名为「暗夜君主」的神秘人物，专门猎杀那些逃脱法律制裁的罪犯。警察全力追捕，黑帮闻风丧胆。没有人知道，白天那个沉默寡言的公司职员，就是夜晚让人恐惧的审判者。这是一部黑暗风格的复仇悬疑漫画，探讨正义与复仇的边界。',
    rating: 4.6,
    totalViews: 980000,
    status: '连载中',
    updatedAt: '2026-07-01',
    chapters: [
      { id: 'ch-4-1', title: '第1话：审判之夜', number: 1, updatedAt: '2026-04-01', isVip: false },
      { id: 'ch-4-2', title: '第2话：双重生活', number: 2, updatedAt: '2026-04-08', isVip: false },
      { id: 'ch-4-3', title: '第3话：猎人与猎物', number: 3, updatedAt: '2026-04-15', isVip: false },
      { id: 'ch-4-4', title: '第4话：警察的目光', number: 4, updatedAt: '2026-04-22', isVip: false },
      { id: 'ch-4-5', title: '第5话：往事浮现', number: 5, updatedAt: '2026-04-29', isVip: true },
      { id: 'ch-4-6', title: '第6话：逼近的真相', number: 6, updatedAt: '2026-05-06', isVip: true },
    ],
    reviews: [
      { id: 'rv-4-1', userName: '暗黑系读者', userAvatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20mysterious%20character%20avatar%20with%20hood%2C%20simple%20portrait%2C%20clean%20background%2C%20dark%20style&width=100&height=100&seq=avatar-06&orientation=squarish', rating: 5, title: '剧情张力十足', content: '很少看到这么有深度的复仇漫画，不只是单纯的爽，每个案件背后都有让人思考的东西。画风也超级适合这个氛围。', date: '2026-06-27' },
    ],
  },
  {
    id: 'comic-5',
    slug: 'sword-and-magic',
    title: '剑与魔法',
    author: '崔贤宇',
    category: '奇幻魔法',
    categorySlug: 'fantasy',
    tags: ['奇幻', '冒险', '魔法', '剑士'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20style%20fantasy%20illustration%20of%20young%20swordsman%20with%20glowing%20sword%20in%20magical%20forest%2C%20mystical%20atmosphere%2C%20warm%20golden%20magic%20particles%2C%20anime%20art%20style%2C%20clean%20epic%20composition&width=800&height=1067&seq=comic-cover-05&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20Korean%20manhwa%20banner%20of%20adventurers%20in%20magical%20landscape%20with%20dragons%2C%20warm%20golden%20lighting%2C%20anime%20art%20style%2C%20cinematic%20wide%20composition%2C%20majestic%20atmosphere&width=1600&height=600&seq=comic-banner-05&orientation=landscape',
    description: '平凡少年意外获得传说中的魔剑，从此踏上成为最强剑士的冒险之旅。',
    longDescription: '在剑与魔法并存的艾尔大陆，少年亚伦一直梦想成为像父亲一样伟大的剑士。然而他天生魔力微弱，被所有人嘲笑。直到有一天，他在古老的遗迹中意外触碰到了传说中的魔剑「芬里尔」— 一把会选择主人的有意识的剑。从此，他的命运彻底改变。与精灵公主、矮人铁匠和龙族后裔一起，他们踏上了对抗黑暗势力的冒险旅程。这是一部充满友情、热血与成长的奇幻史诗。',
    rating: 4.8,
    totalViews: 1560000,
    status: '连载中',
    updatedAt: '2026-07-03',
    chapters: [
      { id: 'ch-5-1', title: '第1话：魔剑觉醒', number: 1, updatedAt: '2026-03-10', isVip: false },
      { id: 'ch-5-2', title: '第2话：精灵之森', number: 2, updatedAt: '2026-03-17', isVip: false },
      { id: 'ch-5-3', title: '第3话：矮人锻造', number: 3, updatedAt: '2026-03-24', isVip: false },
      { id: 'ch-5-4', title: '第4话：龙之契约', number: 4, updatedAt: '2026-03-31', isVip: false },
      { id: 'ch-5-5', title: '第5话：黑暗来袭', number: 5, updatedAt: '2026-04-07', isVip: false },
      { id: 'ch-5-6', title: '第6话：王都之战', number: 6, updatedAt: '2026-04-14', isVip: true },
    ],
    reviews: [
      { id: 'rv-5-1', userName: '奇幻爱好者', userAvatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20character%20avatar%20with%20elf%20ears%2C%20simple%20portrait%2C%20clean%20background%2C%20magical%20style&width=100&height=100&seq=avatar-07&orientation=squarish', rating: 5, title: '世界观太棒了', content: '近几年看过最好的奇幻漫画之一！世界观设定非常完整，每个角色都有血有肉。魔法战斗场面画得特别精彩！', date: '2026-07-02' },
    ],
  },
  {
    id: 'comic-6',
    slug: 'office-secret-love',
    title: '办公室密恋',
    author: '尹彩媛',
    category: '职场生活',
    categorySlug: 'office',
    tags: ['职场', '恋爱', '办公室', '轻松'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20style%20illustration%20of%20young%20professional%20couple%20in%20modern%20office%2C%20warm%20romantic%20atmosphere%2C%20chic%20urban%20style%2C%20anime%20art%20style%2C%20clean%20elegant%20composition&width=800&height=1067&seq=comic-cover-06&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20manhwa%20banner%20of%20stylish%20office%20workers%20in%20city%20high-rise%2C%20warm%20sunset%20lighting%2C%20anime%20art%20style%2C%20cinematic%20wide%20composition%2C%20chic%20atmosphere&width=1600&height=600&seq=comic-banner-06&orientation=landscape',
    description: '公司禁止办公室恋情，但两个相邻工位的同事却在偷偷谈恋爱。每天都像在拍谍战片！',
    longDescription: '徐智恩和张道允是同一家广告公司的职员，工位只隔了一道透明玻璃。公司明令禁止办公室恋情，但他们却在一次加班后的深夜，情不自禁地亲吻了彼此。从此，两人开始了刺激又甜蜜的「地下恋情」 — 在茶水间偷偷牵手，在楼梯间悄悄约会，在同事面前假装只是普通同事。然而纸包不住火，当公司最八卦的同事开始怀疑时，他们的秘密还能守住吗？一部轻松搞笑的职场恋爱漫画。',
    rating: 4.5,
    totalViews: 760000,
    status: '连载中',
    updatedAt: '2026-06-30',
    chapters: [
      { id: 'ch-6-1', title: '第1话：隔壁的同事', number: 1, updatedAt: '2026-04-01', isVip: false },
      { id: 'ch-6-2', title: '第2话：加班之夜', number: 2, updatedAt: '2026-04-08', isVip: false },
      { id: 'ch-6-3', title: '第3话：地下恋情', number: 3, updatedAt: '2026-04-15', isVip: false },
      { id: 'ch-6-4', title: '第4话：危机四伏', number: 4, updatedAt: '2026-04-22', isVip: false },
      { id: 'ch-6-5', title: '第5话：公司团建', number: 5, updatedAt: '2026-04-29', isVip: true },
    ],
    reviews: [
      { id: 'rv-6-1', userName: '职场小白', userAvatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20professional%20woman%20avatar%20with%20glasses%2C%20simple%20portrait%2C%20clean%20background%2C%20smart%20style&width=100&height=100&seq=avatar-08&orientation=squarish', rating: 4, title: '太真实了哈哈哈', content: '办公室恋情的紧张感描写得特别真实！每次看到他们差点被发现的时候都跟着捏一把汗。轻松搞笑又甜蜜。', date: '2026-06-26' },
    ],
  },
  {
    id: 'comic-7',
    slug: 'neighbor-sister',
    title: '邻家姐姐',
    author: '韩素英',
    category: '恋爱浪漫',
    categorySlug: 'romance',
    tags: ['恋爱', '年上', '日常', '温馨'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20style%20illustration%20of%20beautiful%20older%20sister%20type%20woman%20smiling%20warmly%20in%20apartment%20hallway%2C%20warm%20cozy%20atmosphere%2C%20soft%20natural%20lighting%2C%20anime%20art%20style%2C%20clean%20heartwarming%20composition&width=800&height=1067&seq=comic-cover-07&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Cozy%20Korean%20manhwa%20banner%20of%20apartment%20neighborhood%20at%20sunset%2C%20warm%20peaceful%20atmosphere%2C%20anime%20art%20style%2C%20cinematic%20wide%20composition%2C%20heartwarming%20mood&width=1600&height=600&seq=comic-banner-07&orientation=landscape',
    description: '刚搬来的大学生邂逅了住在隔壁的温柔姐姐，日常的点滴相处中，感情悄然滋生。',
    longDescription: '大一新生李俊昊搬进了学校附近的公寓，第一天就遇到了住在隔壁的漂亮姐姐尹智秀。她温柔、体贴，总是在他需要帮助的时候出现 — 借他调味料、帮他收快递、甚至在他生病时照顾他。俊昊发现自己越来越在意这位邻家姐姐的一举一动。然而年龄的差距、生活的轨迹，让两人的关系始终若即若离。这是一部温柔细腻的日常恋爱漫画，描绘了都市中两个孤独灵魂的温暖相遇。',
    rating: 4.7,
    totalViews: 1120000,
    status: '连载中',
    updatedAt: '2026-07-01',
    chapters: [
      { id: 'ch-7-1', title: '第1话：隔壁的陌生人', number: 1, updatedAt: '2026-05-01', isVip: false },
      { id: 'ch-7-2', title: '第2话：借我一勺盐', number: 2, updatedAt: '2026-05-08', isVip: false },
      { id: 'ch-7-3', title: '第3话：雨天的伞', number: 3, updatedAt: '2026-05-15', isVip: false },
      { id: 'ch-7-4', title: '第4话：深夜便利店', number: 4, updatedAt: '2026-05-22', isVip: false },
      { id: 'ch-7-5', title: '第5话：生病的夜晚', number: 5, updatedAt: '2026-05-29', isVip: true },
    ],
    reviews: [
      { id: 'rv-7-1', userName: '温暖治愈系', userAvatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20gentle%20character%20avatar%20with%20soft%20smile%2C%20simple%20portrait%2C%20clean%20background%2C%20warm%20style&width=100&height=100&seq=avatar-09&orientation=squarish', rating: 5, title: '治愈系神作', content: '看了心情会变好的漫画！没有太多狗血剧情，就是简简单单的日常相处，却让人感到特别温暖。', date: '2026-06-28' },
    ],
  },
  {
    id: 'comic-8',
    slug: 'apocalypse-awakening',
    title: '末世觉醒',
    author: '朴泰俊',
    category: '科幻未来',
    categorySlug: 'scifi',
    tags: ['末世', '异能', '生存', '科幻'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20style%20post-apocalyptic%20illustration%20of%20survivor%20with%20glowing%20powers%20in%20ruined%20city%2C%20dramatic%20orange%20sky%2C%20anime%20art%20style%2C%20clean%20intense%20composition&width=800&height=1067&seq=comic-cover-08&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Post-apocalyptic%20Korean%20manhwa%20banner%20of%20ruined%20cityscape%20with%20survivors%2C%20dramatic%20warm%20sunset%20lighting%2C%20anime%20art%20style%2C%20cinematic%20wide%20composition%2C%20intense%20atmosphere&width=1600&height=600&seq=comic-banner-08&orientation=landscape',
    description: '末日降临，丧尸横行，普通大学生在绝境中觉醒异能，带领幸存者寻找最后的希望。',
    longDescription: '2026年，未知病毒席卷全球，感染者变成嗜血的丧尸。大学城瞬间沦为人间地狱。大二学生宋智浩在丧尸围攻中濒临死亡时，身体突然发生了奇异的进化 — 他获得了超人的力量和速度。在这个秩序崩塌的世界里，他必须保护身边的同伴，带领幸存者们穿越丧尸横行的城市，寻找传说中的安全区。然而更可怕的不是丧尸，而是在末世中暴露的人性之恶。',
    rating: 4.6,
    totalViews: 1340000,
    status: '连载中',
    updatedAt: '2026-07-04',
    chapters: [
      { id: 'ch-8-1', title: '第1话：末日降临', number: 1, updatedAt: '2026-05-10', isVip: false },
      { id: 'ch-8-2', title: '第2话：觉醒时刻', number: 2, updatedAt: '2026-05-17', isVip: false },
      { id: 'ch-8-3', title: '第3话：幸存者集结', number: 3, updatedAt: '2026-05-24', isVip: false },
      { id: 'ch-8-4', title: '第4话：人性的考验', number: 4, updatedAt: '2026-05-31', isVip: false },
      { id: 'ch-8-5', title: '第5话：安全区之谜', number: 5, updatedAt: '2026-06-07', isVip: true },
    ],
    reviews: [
      { id: 'rv-8-1', userName: '末世生存者', userAvatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20tough%20survivor%20avatar%20with%20bandana%2C%20simple%20portrait%2C%20clean%20background%2C%20strong%20style&width=100&height=100&seq=avatar-10&orientation=squarish', rating: 5, title: '末日题材新标杆', content: '终于有好看的末世漫画了！丧尸设计得很有压迫感，主角觉醒那段燃爆了。期待后续的势力对抗！', date: '2026-07-03' },
    ],
  },
];

export const featuredComicSlugs = ['her-secret-lessons', 'urban-cultivation-reborn', 'sweet-trap', 'dark-lord', 'sword-and-magic', 'office-secret-love'];

export const latestUpdates = [
  { comicSlug: 'her-secret-lessons', newChapter: '第9话：深夜的讯息', updatedAt: '2026-07-04', isNew: true },
  { comicSlug: 'urban-cultivation-reborn', newChapter: '第8话：昆仑秘境', updatedAt: '2026-07-03', isNew: true },
  { comicSlug: 'sword-and-magic', newChapter: '第6话：王都之战', updatedAt: '2026-07-03', isNew: false },
  { comicSlug: 'sweet-trap', newChapter: '第7话：真心或假意', updatedAt: '2026-07-02', isNew: true },
  { comicSlug: 'apocalypse-awakening', newChapter: '第5话：安全区之谜', updatedAt: '2026-07-04', isNew: true },
  { comicSlug: 'neighbor-sister', newChapter: '第5话：生病的夜晚', updatedAt: '2026-07-01', isNew: false },
];

export const faqs = [
  {
    question: '韩漫屋的漫画都是免费的吗？',
    answer: '是的！韩漫屋上所有漫画均免费提供阅读。我们致力于为广大韩漫爱好者提供高质量的免费韩漫阅读体验，无需付费即可畅享海量韩国漫画资源。部分VIP章节可能需要注册后阅读，但绝大多数内容完全免费开放。',
  },
  {
    question: '什么是下拉式韩漫？怎么看比较方便？',
    answer: '下拉式韩漫是韩国网络漫画的标准阅读模式，您只需向下滑动页面即可连续阅读，无需翻页。这种阅读方式特别适合手机浏览，让您获得流畅沉浸的阅读体验。我们推荐使用手机竖屏模式阅读，体验最佳。',
  },
  {
    question: '韩漫屋的漫画资源是否为正版？',
    answer: '韩漫屋高度重视版权保护，我们与多家韩国漫画平台和出版社保持合作关系，确保平台上的漫画资源具有合法授权。我们支持原创，尊重每一位漫画创作者的劳动成果。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '不同漫画的更新频率不同，热门连载漫画通常每周更新一话。您可以在漫画详情页查看具体的更新计划。建议关注喜欢的漫画，这样更新时您会第一时间收到通知。',
  },
  {
    question: '支持哪些设备阅读？',
    answer: '韩漫屋全面支持PC端、平板和手机端阅读，采用响应式设计自动适配不同屏幕尺寸。无论您使用什么设备，都能获得优质的漫画阅读体验。推荐使用Chrome或Safari浏览器。',
  },
  {
    question: '如何在韩漫屋找到好看的漫画？',
    answer: '您可以通过多种方式发现好漫画：浏览首页的「热门推荐」和「最新更新」栏目；通过分类页面按类型筛选；使用搜索功能直接查找喜欢的作品。我们的推荐算法也会根据您的阅读偏好为您智能推荐漫画。',
  },
];

export function getComicBySlug(slug: string): Comic | undefined {
  return comics.find((c) => c.slug === slug);
}

export function getComicsByCategory(categorySlug: string): Comic[] {
  return comics.filter((c) => c.categorySlug === categorySlug);
}

export function getCategoryBySlug(slug: string): ComicCategory | undefined {
  return categories.find((c) => c.slug === slug);
}

export function getFeaturedComics(): Comic[] {
  return featuredComicSlugs.map((slug) => getComicBySlug(slug)).filter(Boolean) as Comic[];
}

export function getLatestUpdateComics(): { comic: Comic; newChapter: string; updatedAt: string; isNew: boolean }[] {
  return latestUpdates.map((item) => {
    const comic = getComicBySlug(item.comicSlug);
    return comic ? { comic, newChapter: item.newChapter, updatedAt: item.updatedAt, isNew: item.isNew } : null;
  }).filter(Boolean) as { comic: Comic; newChapter: string; updatedAt: string; isNew: boolean }[];
}